<template>
    <v-main class="pa-2" fluid>
        <v-toolbar flat>
            <v-dialog @keydown.esc="datePicker = false" v-model="datePicker" v-if="checkGate('users-mgmt')">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark v-on="on">New Report</v-btn>
                </template>
                <v-date-picker v-model="range" range :first-day-of-week="4" picker-date></v-date-picker>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-btn v-if="checkGate('users-mgmt')" color="gray" to="/settings/users" link><v-icon>mdi-cog-outline</v-icon> &nbsp; Users</v-btn>
            
        </v-toolbar>

        <v-row>
            <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="auto">
                <v-card color="lighten-1">
                    <v-toolbar>
                        <v-toolbar-title>
                            <span class="headline">New Report</span> from {{ dateRangeText }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-form ref="form" v-model="valid" @submit.prevent="save">
                        <v-card-text>
                            <v-container>
                                <v-row>


                                    <v-data-table v-if="wagesbyrange.length > 0" :headers="formHeaders"
                                        :items="wagesbyrange" :items-per-page="50" :loading="loadingForm"
                                        class="elevation-1 wagesForm">

                                        <template v-slot:item.amount_paid="props">

                                            <v-edit-dialog :return-value.sync="props.item.amount_paid"
                                                @save="addIndex(props.item)">
                                                {{ props.item.amount_paid }}
                                                <template v-slot:input>
                                                    <v-text-field v-model="props.item.amount_paid" label="Edit" single-line
                                                        type="number"></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:item.detail="props">
                                            <v-edit-dialog :return-value.sync="props.item.detail" @open="edit">
                                                {{ props.item.detail }}
                                                <template v-slot:input>
                                                    <v-text-field v-model="props.item.detail"
                                                        label="Reason for pay over or under"></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </template>
                                    </v-data-table>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
        </v-row>

        <v-data-table :headers="headers" :items="wages_reports" :loading="loadingForm" :items-per-page="10" class="elevation-1">


            <template v-slot:item.actions="{ item }">

                <v-btn icon small color="red" @click="deleteReport(item.id)">
                    <v-icon center>mdi-delete-forever</v-icon>
                </v-btn>

            </template>
            <template v-slot:item.startDate="{ item }">
                <router-link tag="a" :to="{ path: `/wagesreport/${item.startDate}_${item.endDate}` }">
                    <span>
                        {{ new Date(item.startDate).toLocaleString("en-AU", {
                            timeZone: "UTC", weekday: 'short', month:
                                'short', day: 'numeric'
                        }) }}
                    </span> -
                    <span>
                        {{ new Date(item.endDate).toLocaleString("en-AU", {
                            timeZone: "UTC", weekday: 'short', year:
                                'numeric', month: 'short', day: 'numeric'
                        }) }}
                    </span>
                </router-link>
            </template>
            <template v-slot:item.amount_paid="props">

                <v-edit-dialog :return-value.sync="props.item.amount_paid" @save="addIndex(props.item)"
                    @open="edit(props.item)">
                    {{ props.item.amount_paid }}
                    <template v-slot:input>
                        <v-text-field v-model="props.item.amount_paid" label="Edit" single-line
                            type="number"></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>

            <template v-slot:item.detail="props">
                <v-edit-dialog :return-value.sync="props.item.detail" @open="edit(props.item)" @save="save">
                    {{ props.item.detail }}
                    <template v-slot:input>
                        <v-text-field v-model="props.item.detail" label="Reason for pay over or under"></v-text-field>
                    </template>
                </v-edit-dialog>
            </template>
        </v-data-table>
    </v-main>
</template>

<script>
import { mapState } from 'vuex'
import RangePicker from '../components/RangePicker.vue'

export default {
    components: { RangePicker },
    data() {
        return {
            range: [],
            headers: [
                { text: '', value: 'data-table-expand' },
                { text: 'Latest Reports', align: 'start', sortable: true, value: 'startDate', },
            ],
            datePicker: false,
            dialog: false,
            editedIndex: -1,
            editedIndexes: [],
            valid: true,
            lazy: true,
            isEditing: null,
            editedItem: {
                startDate: '',
                endDate: '',
                wages: []
            },
            loadingForm: false,


            nameRules: [
                v => !!v || 'Name is required',
            ],

        }
    },

    mounted() {
        // if( this.wages_reports.length == 0 )
        this.$store.dispatch('fetchWagesReportsIndex', { grouped: true })

    },


    computed: {
        ...mapState(['wages_reports', 'wagesbyrange']),


        dateRangeText() {
            return this.range.join(' to ')

        },
        rangeSlug() {
            return this.range.join('_')

        },
        formHeaders() {

            return this.getHeaders(this.wagesbyrange)

        },

        reportHeaders() {

            return this.getHeaders(this.wages_reports)

        }

    },


    watch: {

        dialog(val) {
            val || this.close()
        },

        range(val) {


            if (val.length == 2) { //if the two dates have been selected

                this.loadFormData(val)
                //this.reloadData(val)
                this.datePicker = false
                this.loadingForm = false

            }
        }
    },

    methods: {

        addIndex(item) {

            item.over_under = Math.round((parseInt(item.amount_paid) - item.amount_owed) * 10) / 10

            if (this.editedIndex > -1) {
                this.save()
            }

        },



        loadFormData(range) {
            this.loadingForm = true
            this.editedItem.startDate = range[0]
            this.editedItem.endDate = range[1]

            this.$store.dispatch('fetchWagesbyRange', {
                range: range
                
            }).then( response => {
                //this.dialog = true
                this.save()
            })


            
            
        },


        loadData(range) {

            this.$store.dispatch('fetchWagesReportsbyRange', {
                range: range

            })


        },

        edit(item) {
            this.editedIndex = this.wages_reports.indexOf(item)
            //this.editedItem = Object.assign({}, item)
            this.editedItem = this.wages_reports[this.editedIndex]
            //this.save()
        },

        close() {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1

            })
        },


        save() {
            let self = this
            if (this.editedIndex > -1) {

                axios.put('/api/wages_reports/' + this.editedItem.id, this.editedItem)
                    .then(response => {
                        // Object.assign(this.wages_reports[this.editedIndex], this.editedItem)
                        this.close()
                        self.$router.push('/wagesreport/' + this.rangeSlug)


                    })
                    .catch(err => {
                        console.log(err)
                    })


            } else {

                this.editedItem.wages = this.wagesbyrange

                //return this.editedItem
                axios.post('/api/wages_reports', this.editedItem)
                    .then(response => {

                        self.$router.push('/wagesreport/' + this.rangeSlug)
                        //this.$store.dispatch('fetchWagesReportsbyRange')
                        //  this.wages_reports.push(this.editedItem)

                        //this.wages_reports = response.data

                        this.close();

                    })
                    .catch(err => {
                        console.log(err)
                    })

            }

        },

        updateStatus(item) {

            this.editedIndex = this.wages_reports.indexOf(item)
            this.editedItem = Object.assign({}, item)

            axios.put('/api/wages_reports/updateStatus/' + this.editedItem.id, this.editedItem)
                .then(response => {

                    this.close()

                })
                .catch(err => {
                    console.log(err)
                })
        },


        deleteReport(id) {

            confirm('Are you sure you want to delete this Report? This action can not be undone') &&

                axios.delete('/api/wages_reports/' + id)
                    .then(response => {

                        const index = this.wages_reports.map(function (f) { return f.id }).indexOf(id)

                        this.$store.state.wages_reports.splice(index, 1)
                    })
                    .catch(err => {
                        console.log(err)
                    })
        }
    }
}
</script>